// @flow
import {
  getCountBuildings,
  getPageInfo,
} from '../libs/pagewidget';

export const SET_CLIENT_INF = 'client/SET_CLIENT_INF';

function setClientInf(info) {
  return {
    type: SET_CLIENT_INF,
    info,
  };
}

export function getClientInf() {
  return async (dispach) => {
    const res = await fetch('/clients_inf.json');
    const clientInf = await res.json();
    dispach(setClientInf(clientInf));
    dispach(handleGetCountBuildings(clientInf.clients_id));
    dispach(handleGetPageInfo(clientInf.clients_id));
  };
}

export type BuildingCounters = {
  invcount: string,
  invlabel: string,
  rcount: string,
  rlabel: string,
  scount: string,
  slabel: string,
  tcount: string,
  tlabel: ?string,
};

export const SET_BUILDING_COUNTERS = 'client/SET_BUILDING_COUNTERS';

function setBuildingCounters(counters: BuildingCounters) {
  return {
    type: SET_BUILDING_COUNTERS,
    counters: {
      ...counters,
      invcount: parseInt(counters.invcount, 10),
      rcount: parseInt(counters.rcount, 10),
      scount: parseInt(counters.scount, 10),
      tcount: parseInt(counters.tcount, 10),
    },
  };
}

export function handleGetCountBuildings(cid: string) {
  return async (dispach) => {
    const counters = await getCountBuildings(cid);
    dispach(setBuildingCounters(counters))
  };
}

export const SET_PAGE_INFO = 'client/SET_PAGE_INFO';

function setPageInfo(pageInfo: Object) {
  return {
    type: SET_PAGE_INFO,
    pageInfo,
  };
}

export function handleGetPageInfo(cid: string) {
  return async (dispach) => {
    const pageInfo = await getPageInfo(cid);
    dispach(setPageInfo(pageInfo))
  };
}


// WEBPACK FOOTER //
// ./src/actions/client.js